$(document).ready(function () {
  // Collection page color swatches 
  $('#main-collection-product-grid .product_listing_options .color.options').each(function() {
      var $ul = $(this);
      var $lis = $ul.find('li');

      // Check if there are more than 5 list items
      if ($lis.length > 5) {
          // Hide all except the first 5
          $lis.slice(5).hide();

          // Append the plus icon
          var $showMore = $('<li class="show-more">+</li>');
          $ul.append($showMore);

          // Click event to reveal the hidden items
          $showMore.on('click', function() {
              $lis.slice(5).slideDown(); // Show the hidden items
              $showMore.remove(); // Remove the plus icon
          });
      }
  });
});